import * as Yup from "yup";
import i18n from "@/locales/i18n";
import type { CreateCodeFormValues } from "@/types/generatedCode";

// Helper function to get translated error messages
const t = (key: string) => i18n.t(`codeGenerator.validation.${key}`);

/**
 * Validation schema for code creation form
 */
export const createCodeValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required(t("nameRequired"))
    .min(3, t("nameMinLength"))
    .max(255, t("nameMaxLength"))
    .trim(),

  description: Yup.string().max(1000, t("descriptionMaxLength")).optional(),

  tags: Yup.array().of(Yup.string()).max(10, t("tagsMaxCount")).optional(),
});

/**
 * Initial values for code creation form
 */
export const createCodeInitialValues: CreateCodeFormValues = {
  name: "",
  description: "",
  tags: [],
};

// Re-export the type for convenience
export type { CreateCodeFormValues };
